import React from "react";
import "../Event/Event2.css";
import { Link } from "react-router-dom";

const Event2 = () => {
  return (
    <div className="event-section-ev">
      <div className="left-image-ev">
        <div className="overlay-ev">
        <p className="ht">Work Productivity</p>
          <h1>What We Are</h1>
          <p>
            At श्री Var Event & Conference, we are passionate visionaries driven by creativity, precision, 
            and purpose. Our mission is to transform ideas into immersive event experiences that leave a meaningful impact.
          </p>
          <Link to="/contact">
          <button>Contact</button>
          </Link>
        </div>
      </div>

      <div className="right-points-ev">
        <ul>
          <li>✔ Creative Strategy</li>
          <li>✔ Experiential Design</li>
          <li>✔ End-to-End Management</li>
          <li>✔ On-Site Execution</li>
          <li>✔ Brand Engagement</li>
          <li>✔ Innovative Concepts</li>
          <li>✔ Custom Solutions</li>
          <li>✔ Measurable Impact</li>
        </ul>
      </div>
    </div>
  );
};

export default Event2;